import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PropertyCard from '../components/PropertyCard';
import { fetchProperties } from '../apis/properties';
import { normalizeProperty } from '../utils/property';
import heroVilla from '../assets/images/villa.png';

export default function AllPropertiesPage() {
  const [properties, setProperties] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    fetchProperties(controller.signal)
      .then((data) => {
        setProperties(
          data.map((property) => normalizeProperty(property, heroVilla))
        );
        setError('');
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          setError('Unable to load properties right now. Please try again.');
        }
      })
      .finally(() => setIsLoading(false));

    return () => controller.abort();
  }, []);

  return (
    <div className="property-page">
      <Header />
      <main className="home-content all-properties-content">
        <section>
          <h1>All Properties</h1>
          <p>Browse the entire catalog of Dream Home listings.</p>
        </section>

        {isLoading && <p>Loading properties…</p>}
        {error && !isLoading && <p>{error}</p>}

        {!isLoading && !error && (
          <section className="properties-section">
            {properties.map((property) => (
              <PropertyCard key={property.id} property={property} />
            ))}
          </section>
        )}

        {!isLoading && !error && properties.length === 0 && (
          <p>No properties available right now.</p>
        )}
      </main>
      <Footer />
    </div>
  );
}
